<template>
  <div
    class="text-center text-[12px] font-medium rounded-full px-[12px] py-[4px] border-[1px] mb-0 w-auto"
    :style="{ backgroundColor, borderColor, color: borderColor }"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'Pill',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.value ? 'Diprint' : 'Belum Diprint'
    },
    backgroundColor() {
      return this.value ? '#DCF3EB' : '#FFEDED'
    },
    borderColor() {
      return this.value ? '#34A770' : '#E31A1A'
    },
  },
}
</script>
